import Vue from 'vue';
import { Dialog, Toast } from 'cube-ui';
import { $$get, $$post } from '@/service';
import { runtime, isWxMiniprogram, isAliMiniprogram } from '@/utils/runtime';
import { env } from '@/utils';
import { Omega }from '@/utils/util';

Vue.use(Dialog);
Vue.use(Toast);

const platform = () => {
  if (runtime.is('app')) {
    return 'app';
  } else if (isAliMiniprogram()) {
    return 'aliMini';
  } else if (env.isWechat && !isWxMiniprogram()) {
    return 'wxH5';
  } else if (isWxMiniprogram()) {
    return 'wxMini';
  } else if (runtime.is('quickApp')) {
    return 'quick';
  } else {
    return 'web';
  }
};

// eslint-disable-next-line one-var
const Platform = platform();

export default {
  inject: {
    Mixin_Query: {value: 'Mixin_Query', default: null},
    Mixin_Lang: {value: 'Mixin_Lang', default: ''},
    Mixin_City: {value: 'Mixin_City', default: ''},
    Mixin_TraceId: {value: 'Mixin_TraceId', default: ''},
  },
  methods: {
    imgToast(config) {
      const { title, content, cover } = config;
      let style = {
        display: 'none'
      };
      if (cover && cover.length) {
        style = {
          backgroundImage: `url('${cover}')`
        };
      }
      Dialog.$create(
        {
          type: 'alert',
          confirmBtn: {
            text: '我知道了',
            active: true
          }
        },
        createElement => {
          return [
            createElement(
              'div',
              {
                class: {
                  'web-components function-components img-toast-component': true
                },
                slot: 'title'
              },
              [
                createElement('div', {
                  class: {
                    'img-toast-cover': true
                  },
                  style: style
                }),
                createElement(
                  'p',
                  {
                    class: {
                      'img-toast-title': true
                    },
                    slot: 'title'
                  },
                  title
                )
              ]
            ),
            createElement(
              'div',
              {
                class: {
                  'web-components function-components img-toast-component img-toast-content': true
                },
                slot: 'content'
              },
              content
            )
          ];
        }
      ).show();
    },
    msgToast({ msg, type, time = 1000 }) {
      Toast.$create({
        time,
        txt: msg,
        type: type
      }).show();
    },
    $confirm({ title, content, confirmBtn, cancelBtn, onConfirm, onCancel }) {
      Dialog.$create({
        type: 'confirm',
        icon: 'cubeic-alert',
        title,
        content,
        confirmBtn: {
          text: confirmBtn,
          active: true
        },
        cancelBtn: {
          text: cancelBtn,
          active: false
        },
        onConfirm: () => {
          onConfirm && onConfirm();
        },
        onCancel: () => {
          onCancel && onCancel();
        }
      }).show();
    },
    
    // 新版本数据打点
    $omega_dot({ eventId = null, eventLabel = '', attrs = {} }) {
      return Omega({
        eventId,
        eventLabel,
        attrs,
        prefix: 'wyc_accept_center_'
      })
    },
    // 数据打点
    globalOmega({ eventId = null, eventLabel = '', attrs = {} }) {
      return Omega({
        eventId,
        eventLabel,
        attrs,
        prefix: 'accept_center_'
      })
    },
    // 数据打点
    globalOmegaOther({ eventId = null, eventLabel = '', attrs = {} }) {
      return Omega({
        eventId,
        eventLabel,
        attrs,
      })
    },
    // http get
    $get(url, data = {}) {
      let { token } = this.Mixin_User_Info;
      if (!token) {
        // 兼容在小程序和公众号下面，jsbridge获取不到token的情况
        token = this.Mixin_Query.token || this.$route.query.token;
      }
      const patch = {
          token,
          platform: Platform,
          lang: this.Mixin_Lang,
          referrer: document.referrer,
          custom_type: +(
            this.Mixin_Query.customType ||
            this.$route.query.customType ||
            1
          )
          // city_id: +this.Mixin_City || +window.city_id_from_location
        },
        request = { ...patch, ...data };
      $$get(url, request);
    },
    // http post
    $post(url, data = {}) {
      let { token } = this.Mixin_User_Info;
      if (!token) {
        // 兼容在小程序和公众号下面，jsbridge获取不到token的情况
        token = this.Mixin_Query.token || this.$route.query.token;
      }
      const patch = {
          token,
          platform: Platform,
          lang: this.Mixin_Lang,
          referrer: document.referrer,
          custom_type: +(
            this.Mixin_Query.customType ||
            this.$route.query.customType ||
            1
          )
          // city_id: +this.Mixin_City || +window.city_id_from_location
        },
        request = { ...patch, ...data };
      console.log(request);
      return $$post(url, request);
    }
  }
};
